import React from 'react';
import { useTranslation } from 'react-i18next';
import { BdsIcon } from '@/core/constants/webComponents';
import { showFilterBarButtonTooltip } from './tooltipPosition';

interface ToggleViewButtonProps {
  isFilterVisible: boolean;
  onClick: () => void;
  showTooltip: (left: number, top: number, items: string[], rightAligned?: boolean) => void;
  hideTooltip: () => void;
}

export const ToggleViewButton: React.FC<ToggleViewButtonProps> = ({ isFilterVisible, onClick, showTooltip, hideTooltip }) => {
  const { t } = useTranslation();
  const showCurrentTooltip = (target: HTMLElement) => {
    showFilterBarButtonTooltip(target, t('filterBar.toggleView'), showTooltip);
  };

  return (
    <div className={`__icon-button __tooltip-wrapper${isFilterVisible ? '' : ' toggle'}`}>
      <button
        type="button"
        className="filter-bar__action-button"
        data-testid="btn-toggle-view"
        onClick={onClick}
        onMouseEnter={(e) => showCurrentTooltip(e.currentTarget)}
        onFocus={(e) => showCurrentTooltip(e.currentTarget)}
        onTouchStart={(e) => showCurrentTooltip(e.currentTarget)}
        onMouseLeave={hideTooltip}
        onBlur={hideTooltip}
        onTouchEnd={hideTooltip}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
          <BdsIcon
            name={isFilterVisible ? 'screen-full' : 'screen-fill'}
            theme="outline"
            size="medium"
            color="surface-0"
          />
        </div>
      </button>
    </div>
  );
};
